import { Link,useNavigate } from "react-router-dom";
import "./nav_login.css"
//import "../../pages/app-wide.css";


const NavbarLogin = ({hideNav=false, isSignup=false, isLogin=false}) => {
    const navigate = useNavigate();

    const navigateToHome = () =>{
        navigate("/");
    }
  

  return (
    <nav className="login-nav-section-home">
      {/*logo*/}
        <div onClick={navigateToHome}className="login-nav-section-home-logo-container">
            <p className="login-nav-section-home-title-left">Stock</p>
            <div className="login-nav-section-home-title-logo">
            <svg width="35" height="35">
                <circle cx="10" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="20" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="20" cy="20" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="30" cy="30" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="30" cy="20" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
                <circle cx="30" cy="10" r="3.5" fill="none" strokeWidth="1" stroke="#296BE2" />
            </svg>

            </div>
            <p className="login-nav-section-home-title-right">Archives</p>
        </div>

    </nav>
  );
};

export default NavbarLogin;